import { MonitoringCategory } from "@domain/product/monitoring/monitoring-product.service";
import { FloorplanPlaceholder } from "@domain/project/floorplan/floorplan-placeholder";
import { FloorplanService } from "@project/floorplanner/floorplan.service";

export function createMonitoringPlaceholder(
  category: MonitoringCategory,
  floorplanService: FloorplanService,
): FloorplanPlaceholder {
  const floorplan = floorplanService.selectedFloorplan;

  switch (category) {
    case MonitoringCategory.PATIENT_MONITORS:
      floorplanService.addPatientMonitorPlaceholder();
      return floorplan.patientMonitorPlaceholders.at(-1)!;
    case MonitoringCategory.CENTRAL_STATIONS:
      floorplanService.addCentralStationPlaceholder();
      return floorplan.centralStationPlaceholders.at(-1)!;
    case MonitoringCategory.TELEMETRY:
      floorplanService.addTelemetryPlaceholder();
      return floorplan.telemetryPlaceholders.at(-1)!;
    case MonitoringCategory.KVMS:
      floorplanService.addKvmPlaceholder();
      return floorplan.kvmPlaceholders.at(-1)!;
    case MonitoringCategory.DISPLAYS:
      floorplanService.addDisplayPlaceholder();
      return floorplan.displayPlaceholders.at(-1)!;
    case MonitoringCategory.UTILITY:
      floorplanService.addUtilityPlaceholder();
      return floorplan.utilityPlaceholders.at(-1)!;
  }
}
